/**
 * A deploy replaces every hashed bundle and removes the old ones, so a session that was
 * already running when it happened imports chunks the server no longer has.
 *
 * What the import rejects with depends on the engine and on how the server answers a
 * missing file: Chrome and Firefox word the same failure differently, Safari never
 * mentions the URL, and a 404 that an SPA fallback answers with HTML arrives as a MIME
 * type refusal rather than as a missing file at all. None of them is a typed error, so
 * the message is all there is to go on.
 */
const CHUNK_LOAD_MESSAGE = /dynamically imported module|Importing a module script failed|disallowed MIME type/i;

export function isChunkLoadError(error: unknown): boolean {
  if (!error) {
    return false;
  }

  // Kept for bundlers that do throw a typed error - esbuild does not, webpack did.
  if ((error as { name?: string }).name == 'ChunkLoadError') {
    return true;
  }

  const message = typeof error == 'string' ? error : (error as { message?: unknown }).message;
  return typeof message == 'string' && CHUNK_LOAD_MESSAGE.test(message);
}
